<circle-progress
  [percent]="currentValue"
  [radius]="100"
  [space]="-14"
  [outerStrokeWidth]="14"
  [innerStrokeWidth]="14"
  [outerStrokeColor]="outerColor"
  [innerStrokeColor]="'#E1E1E1'"
  [animation]="true"
  [animationDuration]="300"
  [titleFontSize]="titleFontSize ? titleFontSize : 16"
  [unitsFontSize]="0"
  [title]="title"
  [titleColor]="titleColor ? titleColor : '#4A4A4A'"
  [titleFontWeight]="titleFontWeight ? titleFontWeight : 400"
  [showSubtitle]="true"
  [subtitle]="subTitle"
  [subtitleFontSize]="subTitleSize ? subTitleSize : 26"
  [subtitleColor]="currentValue <= 10 ? '#4A4A4A' : outerColor"
  [subtitleFontWeight]="currentValue <= 10 ? 400 : 700"
  [responsive]="true"
></circle-progress>